import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { credentialSelector } from '../../../reducers/credential';
import { apiRequest } from '../../../APIClient';

export const useFetchSchemasOnMount = () => {
  const schemas = useSelector(credentialSelector.getSchemas);
  const isLoading = useSelector(credentialSelector.getSchemaLoading);
  const error = useSelector(credentialSelector.getSchemaError);

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (schemas.length === 0 && !isLoading) {
      dispatch(apiRequest.getSecretsSchema());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return {
    isLoading,
    error,
    schemas,
  };
};
